import { Col, Row } from "antd";
import { HistoryVersionList } from "./history-version-list";
import { HistoryVersionContentV2 } from "./history-version-content-v2";

export const ContentHistoryVersion = () => {
  return (
    <Row>
      <Col sm={20} md={20} className="pr-4 overflow-auto" style={{ height: "500px" }}>
        <HistoryVersionContentV2 />
      </Col>
      <Col sm={4} md={4} className="overflow-auto pl-2" style={{ height: "500px" }}>
        <HistoryVersionList />
      </Col>
    </Row>
  );
};
